import styled from 'styled-components'

import { SecondaryTextError } from 'components/Text'
import { getSpacing } from 'components/helpers/theme-selectors'

export const ProductNotification = styled(SecondaryTextError)`
  display: block;
  margin-bottom: ${props => getSpacing(props).ss};
`
